export const EmailFormSubmitEvent = 'form.submit-email';

export interface EmailFormSubmitPayload {
  email?: string;
  phone?: string;
  formType: string | 'referral';
  formListId?: string;
}
